import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import {
  statusDefaultValue,
  statusSchema,
} from '../Common/DefaultValuesAndSchema';
import { EditStatusForm } from '../Common/EditCategoryForm';
import { GoBackIconButton } from './GoBackIconButton';

export default function EditStatusCategoryMobile() {
  const navigate = useNavigate();
  const { inspectionResultTypeId } = useParams();
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...statusSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...statusDefaultValue,
    },
    shouldUnregister: false,
  });

  const [putCategoryResult, putCategory] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/inspectionResultType/${inspectionResultTypeId}`,
  });
  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      notes: values.notes,
    };
    putCategory({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>상태비고 수정</MobileTitle>
        <Button variant="text" onClick={onSubmit}>
          수정
        </Button>
        <ApiResultModal
          apiResult={putCategoryResult}
          successTitle="수정됐습니다."
          successCode={200}
          onSuccessClose={() => {
            navigate(`/category`);
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
      </Stack>
      <EditStatusForm form={form} statusId={inspectionResultTypeId} />
    </Stack>
  );
}
